/**
 * dds-product-v2.js
 * JS pentru: galerie imagini, lightbox fullscreen (zoom/pan/swipe),
 * calcul dată livrare dinamică, navigare cu săgeți.
 * Extras din dds-main-product-v2.liquid pentru modularitate.
 */

/* ── Calcul dată livrare dinamică ── */
(function() {
  try {
    var nowStr = new Date().toLocaleString("en-US", { timeZone: "Europe/Bucharest" });
    var roNow = new Date(nowStr);
    var hour = roNow.getHours();
    var daysToAdd = hour >= 14 ? 2 : 1;

    /* Calcul Paște ortodox (algoritm Meeus/Jones/Butcher adaptat calendar iulian→gregorian) */
    function getOrthodoxEaster(year) {
      var a = year % 4;
      var b = year % 7;
      var c = year % 19;
      var d2 = (19 * c + 15) % 30;
      var e = (2 * a + 4 * b - d2 + 34) % 7;
      var month = Math.floor((d2 + e + 114) / 31);
      var day   = ((d2 + e + 114) % 31) + 1;
      // Ajustare Gregorian: adauga 13 zile (sec. XX-XXI)
      var julian = new Date(year, month - 1, day + 13);
      return julian;
    }

    /* Sărbători cu dată fixă (MM-DD) */
    function getFixedHolidays(year) {
      return [
        year + '-01-01', // Anul Nou
        year + '-01-02', // Ziua Anului Nou (a 2-a zi)
        year + '-01-24', // Unirea Principatelor
        year + '-05-01', // Ziua Muncii
        year + '-06-01', // Ziua Copilului
        year + '-08-15', // Adormirea Maicii Domnului
        year + '-11-30', // Sf. Andrei
        year + '-12-01', // Ziua Națională
        year + '-12-25', // Crăciun
        year + '-12-26', // Crăciun (a 2-a zi)
      ];
    }

    /* Sărbători mobile legate de Paște ortodox */
    function getEasterHolidays(year) {
      var easter = getOrthodoxEaster(year);
      function addDays(base, n) {
        var d = new Date(base);
        d.setDate(d.getDate() + n);
        return d;
      }
      function fmt(d) {
        var m   = String(d.getMonth() + 1).padStart(2, '0');
        var day = String(d.getDate()).padStart(2, '0');
        return d.getFullYear() + '-' + m + '-' + day;
      }
      return [
        fmt(easter),              // Duminica Paștelui
        fmt(addDays(easter, 1)),  // Lunea Paștelui
        fmt(addDays(easter, 49)), // Duminica Rusaliilor
        fmt(addDays(easter, 50)), // Lunea Rusaliilor
      ];
    }

    /* Set complet sărbători */
    function buildHolidaySet(year) {
      var set = {};
      getFixedHolidays(year).forEach(function(d) { set[d] = true; });
      getEasterHolidays(year).forEach(function(d) { set[d] = true; });
      // Include și sărbătorile anului următor (pentru comenzi la final de an)
      getFixedHolidays(year + 1).forEach(function(d) { set[d] = true; });
      getEasterHolidays(year + 1).forEach(function(d) { set[d] = true; });
      return set;
    }

    /* Verificare dacă o dată e zi nelucrătoare */
    var holidays = buildHolidaySet(roNow.getFullYear());
    function isNonWorkday(date) {
      var dow = date.getDay();
      if (dow === 0 || dow === 6) return true;
      var m   = String(date.getMonth() + 1).padStart(2, '0');
      var day = String(date.getDate()).padStart(2, '0');
      var key = date.getFullYear() + '-' + m + '-' + day;
      return holidays[key] === true;
    }

    /* Adaugă zile lucrătoare */
    function addBizDays(date, days) {
      var r = new Date(date);
      var added = 0;
      while (added < days) {
        r.setDate(r.getDate() + 1);
        if (!isNonWorkday(r)) added++;
      }
      return r;
    }

    var d = addBizDays(roNow, daysToAdd);
    var days   = ["Duminică","Luni","Marți","Miercuri","Joi","Vineri","Sâmbătă"];
    var months = ["Ianuarie","Februarie","Martie","Aprilie","Mai","Iunie","Iulie","August","Septembrie","Octombrie","Noiembrie","Decembrie"];
    var el = document.getElementById('dds-v2-dynamic-date');
    if (el) el.innerText = days[d.getDay()] + ', ' + d.getDate() + ' ' + months[d.getMonth()];
  } catch(e) {
    var el = document.getElementById('dds-v2-dynamic-date');
    if (el) el.innerText = '1-3 zile lucrătoare';
  }
})();

/* ── Galerie + Lightbox ── */
(function() {
  var thumbs       = Array.from(document.querySelectorAll('.dds-v2-thumb-item[data-src]'));
  var galleryTrack = document.getElementById('dds-v2-gallery-track');
  var currentIdx   = 0;

  if (!galleryTrack || thumbs.length === 0) return;

  var isScriptScrolling = false;
  var scrollTimeout;

  /* Navighează la imaginea cu indexul dat */
  window.ddsV2GoToImg = function(idx) {
    if (idx < 0) idx = thumbs.length - 1;
    if (idx >= thumbs.length) idx = 0;
    currentIdx = idx;

    isScriptScrolling = true;
    galleryTrack.scrollTo({ left: galleryTrack.offsetWidth * currentIdx, behavior: 'smooth' });

    thumbs.forEach(function(t, i) { t.classList.toggle('active', i === idx); });

    var thumbsWrap = document.getElementById('dds-v2-thumbs-wrap');
    if (thumbsWrap && thumbs[idx]) {
      var el = thumbs[idx];
      thumbsWrap.scrollTo({ left: el.offsetLeft - thumbsWrap.offsetWidth / 2 + el.offsetWidth / 2, behavior: 'smooth' });
    }

    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(function() { isScriptScrolling = false; }, 400);
  };

  /* Detectare scroll manual în galerie */
  galleryTrack.addEventListener('scroll', function() {
    if (isScriptScrolling) return;
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(function() {
      var newIdx = Math.round(galleryTrack.scrollLeft / galleryTrack.offsetWidth);
      if (newIdx !== currentIdx && newIdx >= 0 && newIdx < thumbs.length) {
        currentIdx = newIdx;
        thumbs.forEach(function(t, i) { t.classList.toggle('active', i === currentIdx); });
        var thumbsWrap = document.getElementById('dds-v2-thumbs-wrap');
        if (thumbsWrap && thumbs[currentIdx]) {
          var el = thumbs[currentIdx];
          thumbsWrap.scrollTo({ left: el.offsetLeft - thumbsWrap.offsetWidth / 2 + el.offsetWidth / 2, behavior: 'smooth' });
        }
      }
    }, 50);
  }, { passive: true });

  /* Butoane săgeată galerie */
  var prevBtn = document.getElementById('dds-gal-prev');
  var nextBtn = document.getElementById('dds-gal-next');
  if (prevBtn) prevBtn.addEventListener('click', function(e) { e.stopPropagation(); window.ddsV2GoToImg(currentIdx - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function(e) { e.stopPropagation(); window.ddsV2GoToImg(currentIdx + 1); });

  /* Butoane săgeată Lightbox */
  var lbPrev = document.getElementById('dds-lightbox-prev');
  var lbNext = document.getElementById('dds-lightbox-next');
  if (lbPrev) lbPrev.addEventListener('click', function(e) { e.stopPropagation(); lbGoToImg(currentIdx - 1); });
  if (lbNext) lbNext.addEventListener('click', function(e) { e.stopPropagation(); lbGoToImg(currentIdx + 1); });

  /* ── LIGHTBOX ── */
  var lb      = document.getElementById('dds-lightbox');
  var lbImg   = document.getElementById('dds-lightbox-img');
  var lbClose = document.getElementById('dds-lightbox-close');
  if (!lb || !lbImg) return;

  function openLightbox() {
    if (thumbs[currentIdx]) lbImg.src = thumbs[currentIdx].dataset.src;
    lbImg.style.transform = 'scale(1)';
    lbScale = 1;
    lb.classList.add('active');
    document.body.style.overflow = 'hidden';
  }
  function closeLightbox() {
    lb.classList.remove('active');
    document.body.style.overflow = '';
  }

  // Click pe imaginea mare → deschide lightbox
  var galleryWrap = document.getElementById('dds-v2-gallery-wrap');
  if (galleryWrap) galleryWrap.addEventListener('click', function(e) {
    if (e.target.closest('.dds-v2-gal-arrow')) return;
    openLightbox();
  });

  lbClose.addEventListener('click', closeLightbox);
  lb.addEventListener('click', function(e) { if (e.target === lb) closeLightbox(); });
  document.addEventListener('keydown', function(e) {
    if (!lb.classList.contains('active')) return;
    if (e.key === 'Escape') closeLightbox();
    if (e.key === 'ArrowLeft')  lbGoToImg(currentIdx - 1);
    if (e.key === 'ArrowRight') lbGoToImg(currentIdx + 1);
  });

  /* ── ZOOM + PAN + SWIPE NAVIGATION ── */
  var lbScale    = 1;
  var lbLastTap  = 0;
  var pinchDist0 = 0;
  var pinchScale0 = 1;
  var lbTransX = 0, lbTransY = 0;
  var panStartX = 0, panStartY = 0;
  var panTransX0 = 0, panTransY0 = 0;
  var isPanning  = false;
  var swipeStartX = 0, swipeStartY = 0;
  var isSwiping  = false;

  function clampTranslate() {
    var vw = window.innerWidth;
    var vh = window.innerHeight;
    var imgW = lbImg.naturalWidth || vw;
    var imgH = lbImg.naturalHeight || vh;
    var displayRatio = Math.min(vw / imgW, vh / imgH);
    var dispW = imgW * displayRatio * lbScale;
    var dispH = imgH * displayRatio * lbScale;
    var maxTx = Math.max(0, (dispW - vw) / 2);
    var maxTy = Math.max(0, (dispH - vh) / 2);
    lbTransX = Math.min(maxTx, Math.max(-maxTx, lbTransX));
    lbTransY = Math.min(maxTy, Math.max(-maxTy, lbTransY));
  }

  function applyTransform() {
    lbImg.style.transition = 'none';
    lbImg.style.transformOrigin = 'center center';
    lbImg.style.transform = 'translate(' + lbTransX + 'px,' + lbTransY + 'px) scale(' + lbScale + ')';
  }

  function resetZoom() {
    lbScale = 1; lbTransX = 0; lbTransY = 0;
    lbImg.style.transition = 'transform 0.25s ease';
    lbImg.style.transformOrigin = 'center center';
    lbImg.style.transform = 'scale(1) translate(0,0)';
  }

  function lbGoToImg(idx) {
    if (idx < 0) idx = thumbs.length - 1;
    if (idx >= thumbs.length) idx = 0;
    resetZoom();
    lbImg.src = thumbs[idx].dataset.src;
    window.ddsV2GoToImg(idx);
  }

  function getDist(t) {
    var dx = t[0].clientX - t[1].clientX;
    var dy = t[0].clientY - t[1].clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }

  lb.addEventListener('touchstart', function(e) {
    if (e.touches.length === 2) {
      e.preventDefault();
      isPanning = false; isSwiping = false;
      pinchDist0  = getDist(e.touches);
      pinchScale0 = lbScale;
    } else if (e.touches.length === 1) {
      var now = Date.now();
      if (now - lbLastTap < 300) {
        // Dublu tap
        if (lbScale > 1) { resetZoom(); } else { lbScale = 2.5; applyTransform(); }
        isPanning = false; isSwiping = false;
      } else if (lbScale > 1) {
        // Pan când zoom
        isPanning = true; isSwiping = false;
        panStartX  = e.touches[0].clientX;
        panStartY  = e.touches[0].clientY;
        panTransX0 = lbTransX;
        panTransY0 = lbTransY;
      } else {
        // Swipe când scale = 1
        isSwiping  = true; isPanning = false;
        swipeStartX = e.touches[0].clientX;
        swipeStartY = e.touches[0].clientY;
      }
      lbLastTap = now;
    }
  }, { passive: false });

  lb.addEventListener('touchmove', function(e) {
    if (e.touches.length === 2) {
      e.preventDefault();
      isPanning = false; isSwiping = false;
      var dist = getDist(e.touches);
      lbScale = Math.min(5, Math.max(1, pinchScale0 * dist / pinchDist0));
      applyTransform();
    } else if (e.touches.length === 1 && isPanning && lbScale > 1) {
      e.preventDefault();
      lbTransX = panTransX0 + (e.touches[0].clientX - panStartX);
      lbTransY = panTransY0 + (e.touches[0].clientY - panStartY);
      clampTranslate();
      applyTransform();
    }
  }, { passive: false });

  lb.addEventListener('touchend', function(e) {
    if (isSwiping && lbScale <= 1) {
      var dx = e.changedTouches[0].clientX - swipeStartX;
      var dy = e.changedTouches[0].clientY - swipeStartY;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
        dx < 0 ? lbGoToImg(currentIdx + 1) : lbGoToImg(currentIdx - 1);
      }
    }
    isPanning = false; isSwiping = false;
    if (lbScale < 1.05) resetZoom();
  }, { passive: true });

  // Zoom scroll pe desktop
  lb.addEventListener('wheel', function(e) {
    e.preventDefault();
    lbScale = Math.min(5, Math.max(1, lbScale - e.deltaY * 0.003));
    clampTranslate();
    applyTransform();
  }, { passive: false });

})();
